module.exports = __webpack_public_path__ + "static/Lobby-Mobile-10-23-aba25421fb48361e19ee38f91716231e.jpg";